"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'settings.rag.description': 'Configure Retrieval-Augmented Generation (RAG) settings for AI knowledge processing',
    'settings.rag.failedToLoad': 'Failed to load RAG settings',
    'settings.rag.savedSuccessfully': 'RAG settings saved successfully',
    'settings.rag.failedToSave': 'Failed to save RAG settings',
    'settings.rag.save': 'Save RAG Settings',
    'settings.rag.indexing.title': 'Indexing Settings',
    'settings.rag.indexing.chunkSize': 'Chunk Size',
    'settings.rag.indexing.chunkSize.help': 'Maximum number of characters per text chunk (100-10000)',
    'settings.rag.indexing.chunkOverlap': 'Chunk Overlap',
    'settings.rag.indexing.chunkOverlap.help': 'Number of overlapping characters between chunks (0-1000)',
    'settings.rag.indexing.separators': 'Text Separators',
    'settings.rag.indexing.separators.placeholder': 'Enter separators separated by commas (e.g., .\\n\\n, \\n)',
    'settings.rag.indexing.separators.help': 'Characters or strings used to split text into chunks. Use \\n for newlines, \\t for tabs. Separate multiple values with commas.',
    'settings.rag.search.title': 'Search Settings',
    'settings.rag.search.defaultMaxResults': 'Default Max Results',
    'settings.rag.search.defaultMaxResults.help': 'Default number of search results to return (1-50)',
    'settings.rag.search.maxResults': 'Maximum Results',
    'settings.rag.search.maxResults.help': 'Maximum number of search results allowed (1-100)',
    'settings.rag.search.similarityThreshold': 'Similarity Threshold',
    'settings.rag.search.similarityThreshold.help': 'Minimum similarity score for search results (0-1)',
};
